var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"el-button--nuttrema-radiocheck-button",class:{ 'is-active': _vm.isActive, 'is-future': _vm.future },attrs:{"type":_vm.buttonType,"value":_vm.label,"size":_vm.size,"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2540b34","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/button/nuttrema-radiocheck-button.vue
// module id = 3271
// module chunks = 0